import TimeSelectPopper from './src/time-select-popper';

TimeSelectPopper.directive = TimeSelectPopper.component.Popper.directive;

export default TimeSelectPopper;
let TimeSelectPopperNew = window._rhinoComponents && window._rhinoComponents.TimeSelectPopperNew;
if (!TimeSelectPopperNew) {
    TimeSelectPopperNew = (r) => {
        window._rhinoComponents.marketRequire('time-select-popper-new', '0.0.1').then((res) => {
            r(res);
        });
    };
}
export {
    TimeSelectPopperNew
};
